export default __webpack_public_path__ + "static/media/por-utilityBill.9874cfcc.png";